export default "__VITE_ASSET__CatiqjcF__"